<template>
	<div class="container">
		<div class="table-page-search-wrapper">
			<a-form layout="inline">
				<a-row style="margin-bottom:15px">
					<a-col :md="7" :sm="7" v-if="handleOptionsData()">
						<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据状态">
							<a-radio-group :default-value="null" :options="typeOptions" @change="onTypeChange" />
						</a-form-item>
					</a-col>
					<a-col :md="17" :sm="17">
						<div style="float: left">
							<a-range-picker :allow-clear="false" style="width: 350px" showTime='true' format="YYYY-MM-DD HH:mm:ss"
								:placeholder="['开始时间', '结束时间']"
								:default-value="[moment().subtract(1, 'hour'), moment(moment().format('YYYY-MM-DD') + ' 23:59:59')]"
								@calendarChange="startChange" @change="onDateChange" @ok="onDateOk"
								:disabled-date="disabledDate" />
							<p style="color: red">时间默认提前一个小时，最大查询时间一天</p>
						</div>
						<a-button type="primary" style="margin-left: 10px" icon="search" @click="searchQuery">查询</a-button>
						<a-button type="primary" style="margin: 0 10px" icon="download" @click="handleExportXls('分钟数据.xls')">导出</a-button>
						<a-button @click="openCol" icon="menu-unfold" type="primary" ghost>
						</a-button>
					</a-col>
				</a-row>
				<col-control ref="colControl" :options="options" @onChange="onChange"></col-control>
				<!--<a-row style="margin:0 0 10px" v-if="colShow">-->
				<!--<a-col :md="24" :sm="24">-->
				<!--<a-checkbox style="margin-right: 10px" :indeterminate="indeterminate" :checked="checkAll"-->
				<!--@change="onCheckAllChange">-->
				<!--全选-->
				<!--</a-checkbox>-->
				<!--<a-checkbox-group v-model="selectCol" name="checkboxgroup" :options="options"-->
				<!--@change="onChange" />-->

				<!--</a-col>-->
				<!--</a-row>-->
			</a-form>
		</div>
		<div>
			<a-tabs default-active-key="1" @change="onTabChange">
				<a-tab-pane key="1" tab="监测数据">
					<a-table id="tb" ref="table" size="middle" bordered :scroll="scroll" :columns="tableColumns"
						:dataSource="dataSource" :pagination="ipagination" :loading="loading"
						@change="handleTableChange">
            <template v-for="slotName in slotNames" v-slot:[slotName]="text, record">
              <slot :name="slotName" :record="record"></slot>
            </template>
          </a-table>
				</a-tab-pane>
				<a-tab-pane key="2" tab="趋势图">
					<trend ref="trend" :trendObj="trendObj" v-if="tabsKey == 2 && showTab"></trend>
					<a-spin v-else size="large" style="display: flex;justify-content: center;" />
				</a-tab-pane>
			</a-tabs>
		</div>
	</div>
</template>
<script>
import colControl from '@/components/colControl/colControl'
import {
	GetSiteIdMixin
} from '@/mixins/GetSiteIdMixin'
import {
	ChangeColMixin
} from '@/mixins/ChangeColMixin1'
import {
	OnlineExportMixin
} from '@/mixins/OnlineExportMixin'
import {
	downloadFile
} from '@/api/manage'
import trend from '@/components/biChart/trend'

import moment from 'moment'
export default {
	name: 'waterData',
	data() {
		return {
			url: '/online/cn2051',
			trendObj: {},
			tabsKey: '',
			tenantId: '',
			showTab: false,
			pageSize: '',
			startTime: '',
			exportUrl: '/online/export/2051',
			exportDataType: '2051',
			moment,
			siteType: '',
			typeOptions: [
				{
					label: '生产数据',
					value: 1,
				},
				{
					label: '未生产数据',
					value: '2',
				},
				{
					label: '综合数据',
					value: null,
				}
			],
      showSite:true
		}
	},
	components: {
		trend,
		colControl
	},
	created() {
		this.siteType = window.sessionStorage.getItem('siteType')
		this.queryParam.stime = moment().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
		this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss')
		if (Date.parse(this.queryParam.etime) - Date.parse(this.queryParam.stime) > (1 * 24 * 60 * 60 * 1000)) {
			this.queryParam.stime = moment(moment().format('YYYY-MM-DD') + ' 00:00:00').format('YYYY-MM-DD HH:mm:ss')
		}
	},
	mixins: [GetSiteIdMixin, ChangeColMixin, OnlineExportMixin],
  props: ['showSiteTree','siteId','otherColumns','slotNames'],
  computed:{
    tableColumns(){
      console.log('columns',this.columns)
      if(this.otherColumns){
        console.log('columns',this.scroll.x)
        console.log('columns',this.columns)
        this.otherColumns.forEach(item=>{
          item.fixed = false
        })
        if(this.scroll.x){
          if(this.columns.some(item=>item.fixed)){
            this.otherColumns.forEach(item=>{
              item.fixed = 'left'
            })
          }
        }else{
          this.columns.forEach(item=>{
            item.fixed = false
          })
        }

        return this.otherColumns.concat(this.columns)
      }else{
        return this.columns
      }
    }
  },
	watch: {
		currentSiteId(value) {
      if(this.showSite) {
        let ids = this.getTreeCurrentId()
        this.queryParam.scopeId = ids[1]
        this.queryParam.scope = ids[0]
        this.checkAll = true
        this.indeterminate = false
        this.delayLoadData()
        if (window.sessionStorage.getItem('siteType')) {
          this.getCol(window.sessionStorage.getItem('siteType'))
          this.siteType = window.sessionStorage.getItem('siteType')
          if (this.siteType != 31) {
            delete this.queryParam.productionStatus
          } else {
            this.queryParam.productionStatus = this.queryParam.productionStatus ? this.queryParam.productionStatus : null
          }
        }
      }
		},
    siteId:{
      handler(value){
        this.queryParam.scope = 1
        this.queryParam.scopeId = value
        this.checkAll = true
        this.indeterminate = false
        this.delayLoadData()
        if (window.sessionStorage.getItem('siteType')) {
          this.getCol(window.sessionStorage.getItem('siteType'))
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler(value){
        if(value === false){
          this.showSite = false
        }
      },
      deep: true,
      immediate:true
    },
		loadNum(value) {
			if (this.options.length > 0) {
				let legendData = []
				let xData = []
				let seriesData = []
				this.options.forEach((item, index) => {
					legendData.push(item.label)
					let newObj = {}
					newObj['name'] = item.label
					newObj['type'] = 'line'
					let arr = []
					this.dataSource.forEach((item1, index1) => {
						if (item1.factor && item1.factor[item.value]) {
							arr.push(item1.factor[item.value].value)
						} else {
							arr.push('')
						}
					})
					newObj['data'] = arr
					seriesData.push(newObj)
				})
				console.log("legendData", legendData)
				this.dataSource.forEach((item, index) => {
					xData.push(item.dataTime)
				})
				let obj = {
					legendData,
					seriesData,
					xData
				}
				this.trendObj = obj
				this.showTab = true
				console.log(obj)
			}
		}
	},
	methods: {
		onTypeChange(e) {
			this.queryParam.productionStatus = e.target.value
		},
		startChange(value) {
			this.startTime = value
		},
		onDateChange: function (value, dateString) {
			if (Date.parse(dateString[1]) - Date.parse(dateString[0]) > (1 * 24 * 60 * 60 * 1000)) {
				this.$message_custom('查询时间范围超过一天', 'warning')
				return
			}
			this.queryParam.stime = dateString[0]
			this.queryParam.etime = dateString[1]
			this.loadData()
		},
		disabledDate(current) {
			return current && Math.abs(Date.parse(current) - Date.parse(this.startTime)) > (1 * 24 * 60 * 60 * 1000);
		},
		onDateOk(value) {
			this.startTime = ''
		},
		onTabChange(key) {
			this.tabsKey = key
			this.showTab = false
			if (key == 1) {
				this.searchCount = true
				this.queryParam.size = this.pageSize
				this.loadData()
			} else {
				// if(this.queryParam.size == undefined){
				//   this.pageSize = 10
				// }else{
				//   this.pageSize = JSON.parse(JSON.stringify(this.queryParam.size))
				// }
				this.searchCount = false
				this.queryParam.size = -1
				this.trendObj = {
					legendData: [],
					seriesData: [],
					xData: []
				}
				this.loadData()
			}
		},
	},
}
</script>
<style lang="less" scoped>
.container {
	padding: 10px 20px 30px;
	box-sizing: border-box;
}

.redText {
	color: red;
	cursor: pointer;
}

.statusText {
	color: #000;
	padding: 3px 10px;
	border-radius: 10px;
}
</style>
